import styled from "@emotion/styled";
import {ReactComponent as svgOrangeGraph} from "../../../../images/800CallLogs/Resources for Call Logs/GraphOrange.svg"

export const GraphOrangeSvg = styled(svgOrangeGraph)`
     width: 38px;
     height: 38px;
`;